import styled from 'styled-components';

import Link from '../Link';
import Logo from '../../icons/LogoIcon';

export const LogoLink = styled(Link)``;

export const StyledLogo = styled(Logo)`
  color: var(--color-white);
  transition: color var(--transition-default);

  @media (${({ theme }) => theme.respondTo.mobile}) {
    width: auto;
    height: 2.4rem;
  }
`;

export const Wrapper = styled.header`
  transition: background-color 0.5s ease;
  background-color: ${({ isScrolled }) => (isScrolled ? 'var(--color-primary)' : 'transparent')};
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  top: 0;
  z-index: 2;
  padding: 2rem 2rem 0 3rem;

  @media (${({ theme }) => theme.respondTo.tablet}) {
    padding: 5rem 4.5rem 1rem 6rem;
  }

  @media (${({ theme }) => theme.respondTo.mobile}) {
    ${({ navIsOpen }) =>
      navIsOpen &&
      `
      ${LogoLink} {
        position: relative;
        z-index: 3;
      }

      ${StyledLogo} {
        color: var(--color-black);
      }
    `}
  }
`;
